module.exports = __webpack_public_path__ + "static/falk-logo-header-c9759b03878413e853ab5d63ea4eded5.png";